import './SkeletonDashboard.css';
import { Skeleton } from './Skeleton';
import { SkeletonList } from './SkeletonList';

export type SkeletonDashboardProps = {
    metricCount?: number;
    hasChart?: boolean;
    hasFeed?: boolean;
    className?: string;
};

function MetricCard() {
    return (
        <div className="skeleton-dashboard__metric">
            <Skeleton width="50%" height="11px" />
            <Skeleton width="65%" height="28px" />
            <Skeleton width="40%" height="11px" />
        </div>
    );
}

export function SkeletonDashboard({
    metricCount = 4,
    hasChart = false,
    hasFeed = false,
    className = '',
}: SkeletonDashboardProps) {
    return (
        <section
            className={`skeleton-dashboard ${className}`}
            role="status"
            aria-busy="true"
            aria-label="Loading dashboard"
        >
            <div className="skeleton-dashboard__header">
                <Skeleton width="40%" height="22px" />
                <Skeleton width="25%" height="14px" />
            </div>

            <div className="skeleton-dashboard__metrics">
                {Array.from({ length: metricCount }, (_, i) => (
                    <MetricCard key={i} />
                ))}
            </div>

            {hasChart && (
                <div className="skeleton-dashboard__chart">
                    <Skeleton width="35%" height="14px" />
                    <Skeleton width="100%" height="200px" borderRadius="12px" />
                </div>
            )}

            {hasFeed && (
                <div className="skeleton-dashboard__feed">
                    <Skeleton width="30%" height="14px" />
                    <SkeletonList count={3} item="row" gap="sm" />
                </div>
            )}
        </section>
    );
}
